<template>
  <div class="page">
    <MainHeader v-bind:page="'Scholing'"></MainHeader>
    <div class="container">
      <div class="row">
        <div class="whole component">
          <img :src="headerImage" width="938px" />
          <h1>Scholing Talentenspel Coaches</h1>
        </div>
      </div>
      <div class="row">
        <div class="whole component">
          <p>Talentenspel liefhebber,</p>
          <p>
            graag nodigen we je uit voor een transformatieve reis door alle acht
            Talentenspel borden, die van december tot april in vier modules van
            twee dagen wordt gegeven door Willem Glaudemans en Marjon te Riele.
          </p>
          <p>
            <a
              target="_blank"
              href="https://www.herbergvanhethart.eu/talentenspel-8-daagse-coaches.pdf"
              >Hierbij de volledige uitnodiging</a
            >
          </p>
        </div>
      </div>
      <div class="row">
        <div class="whole component">
          <p>
            We reizen door de 2 borden van het Jong Talentenspel, de 2
            basisborden en de 4 verdiepingsborden. We boren de wijsheid aan van
            elk bijpassend boek dat Willem heeft geschreven. En we tunen in op
            jouw actuele ontwikkeling en thema's, de hogere trilling van deze
            tijd, wat er voor je mogelijk is en hoe jij ten diepste bij wilt
            dragen. Je kunt het zien als een inwijdingsweg, ontwikkeltraject en
            professionele nascholing.
          </p>

          <p>
            Onze ervaring is dat je in elke volgende fase van je eigen
            ontwikkeling, de reis door jouw acht borden weer als een nieuw
            inwijdingspad ervaart, of je nu wel of niet eerder met een aantal
            van de borden hebt gewerkt.
          </p>

          <p>
            Dit traject is voor coaches ook een voorwaarde om hierna de
            certificeringstraining met de 4 verdiepingsborden te kunnen volgen,
            zodat je er zelf met je klanten mee kunt werken.
          </p>

          <p>
            Marjon heeft in een 8 minuten durende opname nog een keer de reis
            met de acht borden beschreven, zodat je nog beter kunt ervaren hoe
            het bij je past.
          </p>
          <video controls width="100%">
            <source :src="talentenspelVideo" type="video/mp4" />
          </video>
          <br /><br />
          <p>
            Het is fijn om tijdig te weten of je mee wilt doen, i.v.m. het
            reserveren van de ruimte en jouw plek. Mocht je je al hebben
            opgegeven dan hoef je verder niks te doen.
          </p>
          <div class="row">
            <div class="half component">
              <h3>Data</h3>
              <p>
              <ul
                style="display: table;
  margin-right: auto;
  margin-left: auto;"
              >
                <li>Wo 13 en do 14 december 2023</li>

                <li>Ma 29 en di 30 januari 2024</li>

                <li>Ma 11 en di 12 maart 2024</li>

                <li>Ma 22 en di 23 april 2024</li>
              </ul></p>
            </div>
            <div class="half component">
              <h3>Locatie</h3>
              <p>
                De modules vinden plaats bij Zinn/Paaskerk, Oude Utrechtseweg
                4A, 3743 KN in Baarn.
              </p>
            </div>
          </div>

          <p>
            Voor wie: Deze reis is geschikt voor Talentenspel coaches. En voor
            hun klanten, mensen die al een persoonlijk traject bij een van de
            coaches hebben gedaan.
          </p>
          <p>
            Willem Glaudemans en Marjon te Riele
          </p>
          <p>
            Heb je nog vragen over het traject: mail Marjon op
            marjon@rosa-ligna.nl
          </p>
        </div>
      </div>
    </div>
    <MainFooter
      style="display:flex; margin-left: auto; margin-right:auto;"
    ></MainFooter>
  </div>
</template>

<script>
import MainHeader from "../MainHeader";
import MainFooter from "../MainFooter";

export default {
  name: "Nascholing",
  data() {
    return {
      headerImage: require("../../img/talentenspel-traject.jpg"),
      talentenspelVideo: require("../../img/talentenspel-traject.mp4"),
      nascholing_1: require("../../img/nascholing_1.jpg"),
      wereldBord: require("../../img/wereldbord_nl.jpg"),
      levensboomBord: require("../../img/levensboombord_nl.jpg"),
      piramideBord: require("../../img/piramidebord_nl.jpg"),
      zielespiegelBord: require("../../img/zielespiegelbord_nl.jpg")
    };
  },
  computed: {},
  methods: {},
  components: {
    MainHeader,
    MainFooter
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/ScholingTalentenspelCoaches.vue